<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1" id="epig"> </p>
<p class="ep"><span class="epub-b">Fact</span>: The most important relic in Christendom is hiding in plain sight in a monastery church of the Cappucine friars outside the small village of Manoppello, Italy.</p>
<p class="ep"><span class="epub-b">Fact</span>: The House of the Virgin Mary—where evidence suggests that Jesus’ mother lived out her final years—is located in a Muslim country.</p>
<p class="ep"><span class="epub-b">Fact:</span> The Virgin Mary, venerated by most Muslims, is the only woman mentioned by name in the Koran, is only one of eight people to have a chapter named for them in the Koran, and is mentioned more often in the Koran than in the Bible.</p>
<p class="ep"><span class="epub-b">Fact:</span> In 1209, Pope Innocent III initiated the Albigensian Crusade—and with it the Papal Inquisition—to wipe out the Cathar faith, the fastest-growing “heretical” Christian sect in Europe. Although estimates vary widely, the death toll from that Crusade is estimated to be 200,000–1,000,000.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?26cdcace